/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_GbpInputs */

const cs_currency_gbp = /** @type {(inputs: Currency_GbpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GBP — libra`)
};

const en_currency_gbp = /** @type {(inputs: Currency_GbpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GBP — pound sterling`)
};

/**
* | output |
* | --- |
* | "GBP — pound sterling" |
*
* @param {Currency_GbpInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const currency_gbp = /** @type {((inputs?: Currency_GbpInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_GbpInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_currency_gbp(inputs)
	return cs_currency_gbp(inputs)
});